<div id="barrierefreiheitTextanpassungContainer">
  <span id="bspText" [style.fontSize]="aktuellePx + 'px !important'">Dies ist ein Anpassbarer Beispieltext.</span>
  <p>Aktuelle Schriftgröße: {{aktuellePx}}</p>
  <mat-slider
    class="example-margin"
    [max]="20"
    [min]="12"
    (input)="textAnpassen()">
    <input matSliderThumb [(ngModel)]="aktuellePx" #slider>
  </mat-slider>
</div>
